import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const FooterData = async () => {
  try {
    return await getData(`/website/footer/appsetup`);
  } catch (error) {
    console.log(error);
  }
};
